import React, { Component } from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';
import { getIncuBaseList } from '@store/modules/incubator/incubator_list';

const { Option } = Select;

class SelectIncubator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue || '',
    };
  }

  componentDidMount() {
    const { list } = this.props;
    if (!list || list.length === 0) this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({
        value: nextProps.defaultValue,
      });
    }
  }

  loadData = () => {
    this.props.dispatch(getIncuBaseList());
  };

  onChange = e => {
    this.setState({
      value: e,
    });
    this.props.onChange(e);
  };

  render() {
    const { list } = this.props;
    const { value } = this.state;
    return (
      <div style={{ marginBottom: 16 }}>
        <span>选择园区</span>
        <Select
          style={{ width: '320px', marginLeft: '8px' }}
          onChange={this.onChange}
          value={value}
        >
          {list ? list.map(item => <Option key={item.uuid}>{item.name}</Option>) : null}
        </Select>
      </div>
    );
  }
}

export default connect(state => ({ list: state.incubator_list }))(SelectIncubator);



// WEBPACK FOOTER //
// ./src/components/incubator/SelectIncubator.js